import React from "react";
import ImageBG from "../../assets/images/full-banner.jpg";
import ImageMobile from "../../assets/images/full-banner-mobile.jpg";
import { SocialLinks } from "../SocialLinks";
import "./style.css";

export const FullBanner = ({ className, content }) => {
  return (
    <div className={`full-banner position-relative ${className}`}>
      <SocialLinks className="position-absolute social-full-banner d-lg-flex d-none align-items-center flex-column" />
      <img
        className="full-banner img-fluid w-100 d-sm-block d-none"
        alt="Ful banner"
        src={ImageBG}
      />
      <img
        className="full-banner-mobile img-fluid w-100 d-sm-none d-block"
        alt="Ful banner Mobile"
        src={ImageMobile}
      />

      {/* <div className="position-absolute full-banner__text d-lg-flex d-none">
        <p>{content.hero.quote}</p>
      </div> */}

      <div class="full-banner-BG"></div>
    </div>
  );
};
